import {
  FormControlLabel,
  ListSubheader as UnstyledListSubheader,
  MenuItem as UnstyledMenuItem,
  styled,
} from "@mui/material";
import type { ComponentPropsWithRef } from "react";

export const ChecklistFormControl = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontSize: theme.spacing(1.75),
  },
}));

export const ListSubheader = styled(UnstyledListSubheader)({
  pointerEvents: "none",
});

interface MenuItemProps extends ComponentPropsWithRef<typeof UnstyledMenuItem> {
  multiple?: boolean;
}

export const MenuItem = styled(UnstyledMenuItem, {
  shouldForwardProp: (propName: keyof MenuItemProps) => propName !== "multiple",
})<MenuItemProps>(({ theme, multiple }) =>
  multiple
    ? {
        alignItems: "center",
        height: theme.spacing(4.25),
        padding: theme.spacing(0, 1),
      }
    : null,
);
